<template>
  <article>
    <!-- tokenOTP -->
    <otp-input
      v-if="isLogin ? this.$store.state.sessionInfo.userInfo.scurtyDeviVndrDstcd === this.$config.SCURTY_DEVI_VNDR_DSTCD_004 
      : this.scurtyDeviVndrDstcd === this.$config.SCURTY_DEVI_VNDR_DSTCD_004"
      :NOS_INSTANCE_REFERANCE="NOS_INSTANCE_REFERANCE"
    />
    <!-- mOtp 수동 -->
    <motp-input
      v-if="isLogin ? this.$store.state.sessionInfo.userInfo.scurtyDeviVndrDstcd === this.$config.SCURTY_DEVI_VNDR_DSTCD_701
      : this.scurtyDeviVndrDstcd === this.$config.SCURTY_DEVI_VNDR_DSTCD_701"
      :NOS_INSTANCE_REFERANCE="NOS_INSTANCE_REFERANCE"
    />
    <!-- Advancedotp RO, CR -->
    <advanced-otp-input
      v-if="isLogin ? this.$store.state.sessionInfo.userInfo.scurtyDeviVndrDstcd === this.$config.SCURTY_DEVI_VNDR_DSTCD_304
      : this.scurtyDeviVndrDstcd === this.$config.SCURTY_DEVI_VNDR_DSTCD_304"
      :NOS_INSTANCE_REFERANCE="NOS_INSTANCE_REFERANCE"
    />

    <!-- SupplCertn error [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <modal-pop
      :opened.sync="$store.state.common.supplCertn.supplError.active"
      :confirm="$store.state.common.supplCertn.supplError.errBtnText === '' 
      ? 'MOTP-03-01-03-04' 
      : $t(`${$store.state.common.supplCertn.supplError.errBtnText}`)"
      @confirm="typeof $store.state.common.supplCertn.supplError.errBtnAction === 'function' ?
      $store.state.common.supplCertn.supplError.errBtnAction() 
      : $store.state.common.supplCertn.supplError.active = false"
      class="error"
    >
      <template #content>
        <div>
          <div class="error-code">
            <i class="icon icon-error" />
            <div>
              <span>Error Code</span>
              <strong>{{$t(`${$store.state.common.supplCertn.supplError.errCode}`)}}</strong>
            </div>
          </div>
          <p
            v-if="$store.state.common.supplCertn.supplError.errCode=='B99Z0082'"
            v-html="$t(`${$store.state.common.supplCertn.supplError.errMsg}`)"
          ></p>
          <p v-html="$t(`${$store.state.common.supplCertn.supplError.errMsg}`)"></p>
          <p>{{/*전화상담*/$t("MCOM-0000031")}}</p>
          <div class="btn-area">
            <button class="btn lg inline" @click="$goToTel($t(`지점별콜번호_${$store.state.siteCode}`))">
              <i class="icon icon-call" />
              {{$t(`지점별전화번호_${$store.state.siteCode}`)}}
            </button>
          </div>
        </div>
      </template>
    </modal-pop>
    <!-- SupplCertn error [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
  </article>
</template>
<script>
import { mapGetters } from "vuex";
import OtpInput from "@/components/page/common/OtpInput";
import MotpInput from "@/components/page/common/MotpInput";
import AdvancedOtpInput from "@/components/page/common/AdvancedOtpInput";

export default {
  components: {
    OtpInput,
    MotpInput,
    AdvancedOtpInput,
  },
  props: {
    NOS_INSTANCE_REFERANCE: {
      required: false,
      default: () => undefined,
    },
    scurtyDeviVndrDstcd: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("common/supplCertn", ["getSupplCertn"]),
    ...mapGetters(["isLogin", "isCorporationSubUser"]),
  },
  created() {},
  mounted() {
    if (this.isLogin) {
      this.$store.state.common.supplCertn.supplCertn.certnMethdDstcd = this.$store.state.sessionInfo.userInfo.scurtyDeviVndrDstcd;
    } else {
      this.$store.state.common.supplCertn.supplCertn.certnMethdDstcd = this.scurtyDeviVndrDstcd;
    }
  },
  updated() {},
  methods: {},
};
</script>
